import React from 'react'
import { Title } from './TextStyles'

function Text({ text }: any) {
  return <Title>{text}</Title>
}

export default Text
